import {
  computed,
  inject,
  Injectable,
  linkedSignal,
  resource,
  signal,
} from '@angular/core';
import { GarageTask } from '../models/garage-task';
import { TaskRepository } from '../repositories/task.repository';

@Injectable()
export class TaskService {
  #taskRepository = inject(TaskRepository);

  //* PRIVATE API *//
  readonly #tasksResource = resource({
    loader: async () => {
      const request = await this.#taskRepository.retrieveUnproductiveTasks();
      this.#tasks.set(request);
      return request;
    },
  });

  readonly #orderTasksResource = resource({
    params: () => this.#orderId(),
    loader: async ({ params }) => {
      const orderId = params;
      if (!orderId) {
        return null;
      }
      const request = await this.#taskRepository.retrieveForOrderByTypeAndId(orderId);
      this.#orderTasks.set(request);
      return request;
    },
  });

  readonly #tasks = signal<GarageTask[]>([]);
  readonly #orderId = signal<number | null>(null);
  readonly #orderTasks = signal<GarageTask[]>([]);

  //* PUBLIC API *//
  readonly tasksLoading = computed(() => this.#tasksResource.isLoading());
  readonly orderTasksLoading = computed(() => this.#orderTasksResource.isLoading());

  readonly tasks = linkedSignal(() => this.#tasks());
  readonly orderTasks = linkedSignal(() => this.#orderTasks());

  searchGarageTasks = (value: string | null | undefined) => {
    const tasks = this.#tasks();
    if (!value) {
      this.tasks.set(tasks);
      return;
    }
    const searchText = value.toLowerCase();
    const result = tasks.filter((task: GarageTask) => {
      return task.description.toLowerCase().includes(searchText.toLowerCase());
    });
    this.tasks.set(result);
    return;
  };

  loadOrderTasksByOrderId(id: number) {
    this.#orderId.set(id);
  }

  reloadAll(): void {
    this.#tasksResource.reload();
    this.#orderTasksResource.reload();
  }
}
